export const toastMessageStyle = {
  '& .SnackbarContent-root': {
    color: 'black',
    backgroundColor: 'rgb(255,255,255)',
    borderRadius: '12px',
    height: '56px',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '15px',
    lineHeight: '24px',
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.08), 0px 1px 10px rgba(0, 0, 0, 0.16)',
    justifyContent: 'center',
    padding: '0',
    minWidth: 'inherit !important',
    '& .SnackbarItem-message': {
      padding: '16px 20px',
    },
  },
}
export default toastMessageStyle
